import { PromoContent } from '@cinemark/content-api-client';
import { PromotionalImage } from './promotional-image';
import { PromotionalText } from './promotional-text/promotional-text';
import { PromotionalVideo } from './promotional-video/promotional-video';

type PromotionalImageWithTextProps = {
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalImageWithTextAndVideo = ({ dataLinkCategory, dataLinkName, promoContent }: PromotionalImageWithTextProps): React.JSX.Element | null => {
  if (!promoContent) {
    return null;
  }

  return (
    <div>
      <PromotionalImage dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        promoContent={promoContent}
      />
      <PromotionalText dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        promoContent={promoContent}
      />
      <PromotionalVideo hideTitle
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        promoContent={promoContent}
      />
    </div>
  );
};
